import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "../constant/api.const";
import { SendNotificationModel } from "../model";
import { BaseResponseModel, SelectListItem } from "app/core/models";
import { HTTP_SERVICE, HttpInterface } from "app/core/services";
import { SendNotificationInterface } from "./send-notification.interface";

@Injectable()

export class SendNotificationService implements SendNotificationInterface {

  constructor(
    @Inject(HTTP_SERVICE) private _httpInterface: HttpInterface
  ) { }

  getsendNotificationList(sendNotificationData: SendNotificationModel): Observable<BaseResponseModel<SendNotificationModel>> {
    return this._httpInterface.post(API.SEND_NOTIFICATION, sendNotificationData);
  }

}
